const lang = i18n.database.table.users;

export default [
  {
    key: 'name',
    name: lang.columns.name
  },
  {
    key: 'email',
    name: lang.columns.email
  },
  {
    key: 'country.name',
    name: i18n.database.table.countries.columns.name
  },
  {
    key: 'roles.name',
    name: i18n.database.table.roles.singular,
    orderable: false
  },
]
